import { Color } from "../../types";
import { IconProps } from "./types";

export const RepetitionIcon: React.FC<IconProps> = ({
  style,
  width = 16,
  height = width,
  color = Color.Secondary88,
}) => {
  return (
    <svg
      style={style}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_15698)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.90907 0.909073C7.14339 0.674759 7.52329 0.674759 7.7576 0.909073L9.7576 2.90907C9.99192 3.14339 9.99192 3.52329 9.7576 3.7576L7.7576 5.7576C7.52329 5.99192 7.14339 5.99192 6.90907 5.7576C6.67476 5.52329 6.67476 5.14339 6.90907 4.90907L7.88481 3.93334H6C3.75405 3.93334 1.93334 5.75405 1.93334 8C1.93334 9.62135 2.88214 11.0223 4.25746 11.6756C4.55677 11.8178 4.68415 12.1757 4.54196 12.475C4.39977 12.7744 4.04186 12.9017 3.74255 12.7595C1.9646 11.9149 0.733337 10.1019 0.733337 8C0.733337 5.0913 3.0913 2.73334 6 2.73334H7.88481L6.90907 1.7576C6.67476 1.52329 6.67476 1.14339 6.90907 0.909073ZM11.458 3.52497C11.6002 3.22566 11.9581 3.09828 12.2575 3.24047C14.0354 4.08508 15.2667 5.89816 15.2667 8C15.2667 10.9087 12.9087 13.2667 10 13.2667H8.1152L9.09093 14.2424C9.32525 14.4767 9.32525 14.8566 9.09093 15.0909C8.85662 15.3253 8.47672 15.3253 8.24241 15.0909L6.24241 13.0909C6.00809 12.8566 6.00809 12.4767 6.24241 12.2424L8.24241 10.2424C8.47672 10.0081 8.85662 10.0081 9.09093 10.2424C9.32525 10.4767 9.32525 10.8566 9.09093 11.0909L8.1152 12.0667H10C12.246 12.0667 14.0667 10.246 14.0667 8C14.0667 6.37866 13.1179 4.97772 11.7425 4.32438C11.4432 4.18219 11.3159 3.82428 11.458 3.52497Z"
          fill="#161925"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_15698">
          <rect width={width} height={height} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
